import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center gap-2 min-w-0"
}
const _hoisted_2 = { class: "text-xs text-gray-600 truncate" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "pointer-events-none absolute h-full w-full rounded-md"
}, null, -1)

import { Switch } from "@headlessui/vue";
import { useLiveImageSetting } from "@/composables/stream";


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveSwitch',
  setup(__props) {

const { useLiveImage, setUseLiveImage } = useLiveImageSetting();

return (_ctx: any,_cache: any) => {
  return (_ctx.hasPermission('live_camera_feature_user'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("video_player.low_bandwidth_mode")), 1),
        _createVNode(_unref(Switch), {
          modelValue: _unref(useLiveImage),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(setUseLiveImage)($event))),
          class: "group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createElementVNode("span", {
              "aria-hidden": "true",
              class: _normalizeClass([
          _unref(useLiveImage) ? 'bg-yellow-500' : 'bg-gray-200',
          'pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out',
        ])
            }, null, 2),
            _createElementVNode("span", {
              "aria-hidden": "true",
              class: _normalizeClass([
          _unref(useLiveImage) ? 'translate-x-5' : 'translate-x-0',
          'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out',
        ])
            }, null, 2)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}
}

})